import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f24e030"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "search__btn" }

import { PropType } from 'vue'
import { clearData } from '@/utils/tools'


const __default__ = {
  name: 'SearchForm'
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  isShowBtns: {
    type: Boolean,
    default: true
  },
  ismForm: {
    type: Boolean,
    default: false,
  },
  isInline: {
    type: Boolean,
    default: true,
  },
  globalWidth: {
    type: String,
    default: '300px', // 300px
  },
  // 表达对象
  formData: {
    type: Object,
    default: () => ({}),
  },
  // 表单校验对象
  formRules: {
    type: Object,
    default: () => ({}),
  },
  // labe默认长度
  labelWidth: {
    type: String,
    default: '120px', // 120px
  },
  // 表单列表
  formList: {
    type: Array as PropType<SearchItemType[]>,
    default: () => [],
    // default: [],
  },
  size: {
    type: Object,
    default: {
      sm: 24,
      md: {},
      lg: 12,
      xl: 8,
      xs: {},
    },
  },
  gutter: {
    type: Number,
    default: 130,
  },
  isCardBlock: {
    type: Boolean,
    default: true,
  }
},
  emits: ['search', 'reset'],
  setup(__props, { emit }) {

const props = __props;





const showController = (item: any) => {
  const { controller } = item
  return controller ? controller(props.formData[item.prop], props.formData, item) : true
}

const focusMethods = () => {
  console.log('focus')
}

// 抛出搜索按钮事件
const search = () => {
  emit('search', props.formData)
}

// 抛出重置按钮事件
const reset = () => {
  clearData(props.formData)
  emit('reset')
}


return (_ctx: any,_cache: any) => {
  const _component_WidgetItem = _resolveComponent("WidgetItem")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["form-box", { 'mk-card-block': __props.isCardBlock ?? true }])
  }, [
    _createVNode(_component_el_form, {
      model: __props.formData,
      "label-width": __props.labelWidth,
      rules: __props.formRules,
      ref: "mForm",
      class: "search-form",
      inline: __props.isInline
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: __props.gutter }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formList, (item, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, null, [
                (showController(item) && !item.suffix)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 0,
                      sm: __props.size.sm,
                      md: __props.size.md,
                      lg: __props.size.lg,
                      xl: __props.size.xl,
                      xs: __props.size.xs,
                      span: item.span || 24 / 3,
                      style: _normalizeStyle({ minWidth: item.labelWidth })
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          class: _normalizeClass(item.class ? item.class : ''),
                          label: _ctx.$t(item.label),
                          prop: item.prop,
                          "label-width": item.labelWidth ? item.labelWidth : '',
                          onFocus: focusMethods,
                          style: {"width":"102%"}
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_WidgetItem, {
                              "widget-config": item,
                              "widget-data": __props.formData
                            }, null, 8, ["widget-config", "widget-data"])
                          ]),
                          _: 2
                        }, 1032, ["class", "label", "prop", "label-width"])
                      ]),
                      _: 2
                    }, 1032, ["sm", "md", "lg", "xl", "xs", "span", "style"]))
                  : _createCommentVNode("", true),
                (showController(item) && item.suffix)
                  ? (_openBlock(), _createBlock(_component_el_col, {
                      key: 1,
                      sm: __props.size.sm,
                      md: __props.size.md,
                      lg: __props.size.lg,
                      xl: __props.size.xl,
                      xs: __props.size.xs,
                      span: item.span || 24 / 3,
                      style: _normalizeStyle({ minWidth: item.labelWidth })
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          style: _normalizeStyle(item.suffix ? 'display: flex;' : '')
                        }, [
                          _createVNode(_component_el_form_item, {
                            class: _normalizeClass(item.class ? item.class : ''),
                            label: _ctx.$t(item.label),
                            prop: item.prop,
                            "label-width": item.labelWidth ? item.labelWidth : '',
                            onFocus: focusMethods,
                            style: {"width":"102%"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WidgetItem, {
                                "widget-config": item,
                                "widget-data": __props.formData
                              }, null, 8, ["widget-config", "widget-data"])
                            ]),
                            _: 2
                          }, 1032, ["class", "label", "prop", "label-width"]),
                          _renderSlot(_ctx.$slots, "suffix", _normalizeProps(_guardReactiveProps(item)))
                        ], 4)
                      ]),
                      _: 2
                    }, 1032, ["sm", "md", "lg", "xl", "xs", "span", "style"]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 256)),
            (__props.isShowBtns)
              ? (_openBlock(), _createBlock(_component_el_col, {
                  key: 0,
                  sm: __props.size.sm,
                  md: __props.size.md,
                  lg: __props.size.lg,
                  xl: __props.size.xl,
                  xs: __props.size.xs,
                  style: {"margin-left":"auto"}
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "searchItem", {}, () => [
                      _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_el_button, {
                          class: "mk-op-btn mk-op-btn-main",
                          onClick: search
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('查询')), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_button, {
                          class: "mk-op-btn mk-op-btn-main mk-op-btn-non-focus",
                          onClick: reset
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('重置')), 1)
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 3
                }, 8, ["sm", "md", "lg", "xl", "xs"]))
              : _createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["gutter"])
      ]),
      _: 3
    }, 8, ["model", "label-width", "rules", "inline"])
  ], 2))
}
}

})